/**
 * 화면 위치 헤더(X-Client-App·X-Audit-Screen) — 계약 AUDIT 2절 `screen`·`source.app`.
 * 서버는 cleanScreen()·cleanClientApp() 으로 받고 이용 내역에 표시용으로만 남긴다(판정에 쓰지 않음).
 * Vue·axios 를 들이지 않는 순수 모듈이라 node --test 로 시험한다(`__tests__/clientHeaders.test.mjs`).
 */
export const CLIENT_APP = "admin-certilife";

// 서버 cleanScreen() 과 같은 식. 맞지 않으면 헤더를 빼고 보낸다(서버도 버림)
const SCREEN_RE = /^[A-Za-z0-9_.:/#-]{1,64}$/;

let currentScreen;

/** 라우트 → 화면 위치 값: name(형식이 맞을 때) → 경로 틀(/customer/:id) → 없음 */
export const screenOf = (route) => {
  if (!route) return undefined;
  if (typeof route.name === "string" && SCREEN_RE.test(route.name)) return route.name;
  const matched = Array.isArray(route.matched) ? route.matched : [];
  const path = matched.length ? matched[matched.length - 1].path : undefined;
  return typeof path === "string" && SCREEN_RE.test(path) ? path : undefined;
};

/** router.afterEach 에서 부른다 */
export const setAuditScreen = (route) => {
  currentScreen = screenOf(route);
};

/** axios 요청 설정에 두 헤더를 붙인다(화면 위치를 모르면 그 헤더만 뺌) */
export const withClientHeaders = (config) => {
  config.headers = config.headers || {};
  config.headers["X-Client-App"] = CLIENT_APP;
  if (currentScreen) config.headers["X-Audit-Screen"] = currentScreen;
  else delete config.headers["X-Audit-Screen"];
  return config;
};
